import { render } from "./VendorIndividualPersonForm.vue?vue&type=template&id=211836a4&scoped=true"
import script from "./VendorIndividualPersonForm.vue?vue&type=script&lang=js"
export * from "./VendorIndividualPersonForm.vue?vue&type=script&lang=js"

import "./VendorIndividualPersonForm.vue?vue&type=style&index=0&id=211836a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211836a4"]])

export default __exports__